import { createSlice, PayloadAction } from '@reduxjs/toolkit'; //eslint-disable-line sort-imports
import { RootState } from '../../app/store';
import { User } from '../../types/User';

interface UserState {
  user: User | undefined;
  status: 'idle' | 'loading' | 'error';
  error: string | undefined;
}

const initialState: UserState = {
  user: undefined,
  status: 'idle',
  error: undefined,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setStatus: (state, action: PayloadAction<{ status: 'idle' | 'loading' | 'error'; error: undefined | string }>) => {
      state.status = action.payload.status;
      state.error = action.payload.error;
    },
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
  },
});

export const { setStatus, setUser } = userSlice.actions;

//Selectors
export const selectUser = (state: RootState) => state.user;

export default userSlice.reducer;
